import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import App from './App';
import { ThemeProvider } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { SeasonYearProvider } from './context/SeasonYearContext';
import { theme } from './theme'; // Import our accessible theme
import './index.css'; // Ensure CSS is loaded

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (!token) return config;

  try {
    const target = new URL(config.url ?? '', config.baseURL || window.location.origin);
    const apiHost = new URL(import.meta.env.VITE_API_URL || `${window.location.origin}/api`, window.location.origin);
    if (target.origin !== apiHost.origin) return config;
    const apiPath = apiHost.pathname.endsWith('/') ? apiHost.pathname : `${apiHost.pathname}/`;
    const targetPath = target.pathname.endsWith('/') ? target.pathname : `${target.pathname}/`;
    if (!targetPath.startsWith(apiPath)) return config;
  } catch {
    return config;
  }

  const headers = (config.headers ?? {}) as Record<string, unknown>;
  const hasAuth = Object.keys(headers).some((k) => k.toLowerCase() === 'authorization');
  if (!hasAuth) {
    headers.Authorization = `Bearer ${token}`;
    config.headers = headers as typeof config.headers;
  }
  return config;
});

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ThemeProvider theme={theme}>
          <SeasonYearProvider>
            <AuthProvider>
              <NotificationProvider>
                <App />
              </NotificationProvider>
            </AuthProvider>
          </SeasonYearProvider>
        </ThemeProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
} else {
  console.error('Failed to find the root element. Check your index.html file.');
} 